/* eslint-disable func-names */
import {
  getCurrentUser,
} from 'aws-amplify/auth';

import store from '~/store';

export default async function (to, from, next) {
  if (!window.cognito) {
    // Redirect to "notenant" page when we are not able to retrieve cognito info
    if (to?.name !== 'notenant') next({ name: 'notenant' });
    else next();
  }

  let currentUser = null;
  try {
    currentUser = await getCurrentUser();
  } catch {
    currentUser = null;
  }

  if (to.meta.isAnonymous || !!currentUser) {
    // Ensure user data is loaded in store before continuing
    if (currentUser && !store.state.auth.user) {
      try {
        await store.dispatch('auth/fetchUser');
      } catch (error) {
        // La garde doit rendre la main quoi qu'il arrive : sans `next()`, vue-router
        // abandonne la navigation et l'écran reste vide, sans rien dire. C'est ce que
        // produisait un chargement refusé — le cas d'une session ouverte par l'annuaire que
        // Keyprod n'accepte pas.
        // eslint-disable-next-line no-console
        console.error('Could not load the application user', error);
      }
    }

    // Une session ouverte côté Cognito, et personne à charger de notre côté : c'est un refus,
    // pas une page à servir. Les routes anonymes se laissent voir — la connexion doit pouvoir
    // dire pourquoi —, les autres y renvoient sans identité.
    if (!to.meta.isAnonymous && !store.state.auth.user) {
      next({ name: 'login' });

      return;
    }

    // When meta "isAnonymous" is set to true, user can access the route anonymously
    next();
  } else {
    // No Cognito session any more (expired, revoked, or signed out from another tab): end the
    // SPA session too, so the login page is reached without the previous user nor their cache.
    await store.dispatch('auth/logout');
    store.dispatch('dashboard/reset');
    // Redirect to login page with the original destination
    if (to?.fullPath) {
      next({
        name: 'login',
        query: { redirect: to.fullPath },
      });
    } else {
      next({ name: 'login' });
    }
  }
}
